import Swal from 'sweetalert2';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import EmbedIcon from '../icons/boa.svg';

export default class EmbedSocial extends Plugin {
  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add('embedSocial', (locale) => {
      const view = new ButtonView(locale);

      view.set({
        label: 'Coloque a url do embed',
        icon: EmbedIcon,
        tooltip: true,
      });

      view.on('execute', async () => {
        const { value: url } = await Swal.fire({
          input: 'url',
          inputPlaceholder: 'Coloque a url do embed',
        });

        if (url) {
          editor.model.change(() => {
            const content = ` <p>[embed]${url}[/embed]</p>`;

            const viewFragment = editor.data.processor.toView(content);
            const modelFragment = editor.data.toModel(viewFragment);

            editor.model.insertContent(
              modelFragment,
              editor.model.document.selection
            );
          });
        }
      });

      return view;
    });
  }
}
